import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Divider, Form, Input, message, Row, Select } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { IListColumn, ISortColumn, PaginationResponse } from 'src/@types/search-params';
import {
  getAllDataPackageNew,
  getRegisterAndCancelHistory,
} from 'src/api/register_and_cancel_and_load_package';
import TableContent from 'src/components/CTable';
import useWindowSize from 'src/hooks/useWindowSize';
import { useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { SimStatusEnum } from 'src/shared/enum/change_sim';
import { TransactionHistoryType } from 'src/shared/enum/localpay';
import { RequestPackageType } from 'src/shared/enum/register_cancel';
import { IConnectionBatch, IOverFlowOrderDetailResponse } from 'src/shared/interface/connection';
import { IOrderStatus, IPackageAssigned } from 'src/shared/interface/package_assigned';
import {
  exportExcel,
  formatDate,
  formatMoney,
  formatPhoneNumberV2,
  nonAccentVietnamese,
  parseQueryString,
  renderSubType,
} from 'src/utils';
import { requestTypeToString } from 'src/utils/register_cancel';
import { renderOptionSubType } from 'src/utils/subType';
import CGridView from 'src/components/CGridView';
import { usePermission } from 'src/hooks/usePermission';

const HistoryRegister = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { openTabs, activeKeyId } = useAppSelector((state) => state.global);
  const [data, setData] = useState<PaginationResponse<[IConnectionBatch]>>();
  const [_, setSearchParams] = useSearchParams();
  const size = useWindowSize();
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');
  const [sortColumn] = useState<ISortColumn>();
  const params = location.search;

  const [dataPackage, setDataPackage] = useState<IOrderStatus[]>([]);

  const { hasPermission, PERMISSIONS } = usePermission();

  useEffect(() => {
    fetchGetPackageAssigned();
    fetchListConnectionHistory();
    form.resetFields();
  }, [activeKeyId]);

  const fetchGetPackageAssigned = async () => {
    await getAllDataPackageNew().then((res: any) => {
      if (res) {
        const dataPackage: IOrderStatus[] = [{ value: '', label: 'Tất cả' }];
        res?.map((item: any) => {
          dataPackage?.push({
            label: item?.mbfName ?? '',
            value: item?.mbfCode ?? '',
          });
        });
        setDataPackage(dataPackage);
      }
    });
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current >= moment().endOf('day');
  };

  const handleFormSearch = (value: any) => {
    let values = { ...value };
    values = {
      ...values,
      search: values.search?.trim(),
      dateFrom:
        value.dateRange && value?.dateRange[0]
          ? value?.dateRange[0].format('YYYY-MM-DD')
          : value.dateFrom ?? undefined,
      dateTo:
        value.dateRange && value?.dateRange[1]
          ? value?.dateRange[1].format('YYYY-MM-DD')
          : value.dateTo ?? undefined,
      dateRange: undefined,
      pageIndex: 1,
      pageSize: 10,
    };
    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        delete values[key];
      }
    });
    fetchListConnectionHistory(values);
    setSearchParams(values);
  };

  const fetchListConnectionHistory = async (params = {}) => {
    const res = await getRegisterAndCancelHistory(params);
    if (res) {
      setData(res);
    }
  };

  const type = (type: string) => {
    if (type === RequestPackageType.CANCEL) {
      return 'cancel';
    } else if (type === RequestPackageType.REGISTER) {
      return 'register';
    } else if (type === RequestPackageType.DATACODE) {
      return 'data-load';
    }
    return 'register';
  };
  const label = (type: string) => {
    if (type === RequestPackageType.CANCEL) {
      return 'Xem chi tiết Huỷ gói ';
    } else if (type === RequestPackageType.REGISTER) {
      return 'Xem chi tiết Đăng ký gói ';
    } else if (type === RequestPackageType.DATACODE) {
      return 'Xem chi tiết Nạp data ';
    }
    return 'Xem chi tiết Đăng ký gói ';
  };

  const handleDetailOrder = (order: any) => {
    try {
      dispatch(
        setGlobalState({
          activeKeyMenu: `register-and-cancel-and-load-package/${type(order.type)}/detail?id=${
            order.orderId
          }`,
        }),
      );
      if (
        !openTabs.find(
          (tab) =>
            tab.key ===
            `register-and-cancel-and-load-package/${type(order.type)}/detail?id=${order.orderId}`,
        )
      ) {
        dispatch(
          setGlobalState({
            openTabs: [
              ...openTabs,
              {
                label: label(order.type) + order.orderId,
                children: '',
                key: `register-and-cancel-and-load-package/${type(order.type)}/detail?id=${
                  order.orderId
                }`,
                closable: true,
              },
            ],
          }),
        );
      }
    } catch (error) {
      navigate(`/register-and-cancel-and-load-package/register/history`);
    }
  };

  const handleExport = () => {
    const link = document.createElement('a');
    link.target = '_blank';
    link.download = `Lich_su_dang_ky_dich_vu_${moment().format('DDMMYYYYHHmmss')}.xlsx`;
    const url = process.env.REACT_APP_API_URL + '/api/DataPackage/export-history' + params;
    exportExcel(url)
      .then((res) => {
        link.href = URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.ms-excel' }));
        link.click();
      })
      .catch((error) => {
        if (error.status === 403) {
          message.error(`Tài khoản của bạn không có quyền truy cập vào chức năng này`);
        }
      });
  };

  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', width: 20, isHideSort: true },
    {
      name: 'Mã đơn',
      fieldName: 'orderId',
      renderSpecialCard: (record) => {
        return (
          <button
            className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent text-blue-400 font-semibold`}
            onClick={() => handleDetailOrder(record)}
          >
            {record.orderId ?? ''}
          </button>
        );
      },
      isHideSort: true,
    },
    { name: 'Mã DN', fieldName: 'enterpriseId', isHideSort: true },
    { name: 'Tên DN', fieldName: 'enterpriseName', isHideSort: true },
    {
      name: 'Loại đơn hàng',
      fieldName: 'type',
      renderSpecialCard: (record) => {
        return <span>{record.type && requestTypeToString(record.type)}</span>;
      },
      isHideSort: true,
    },
    {
      name: 'Số thuê bao',
      fieldName: 'phoneNumber',
      isHideSort: true,
      renderSpecialCard: (record) => {
        return <span>{formatPhoneNumberV2(record?.phoneNumber)}</span>;
      },
    },
    {
      name: 'Loại thuê bao',
      fieldName: 'subType',
      isHideSort: true,
      renderSpecialCard: (record) => {
        return <p>{renderSubType('', record?.subType)}</p>;
      },
    },
    {
      name: 'Mã gói',
      fieldName: 'mbfCode',
      isHideSort: true,
    },
    {
      name: 'Tên gói',
      fieldName: 'mbfName',
      isHideSort: true,
    },
    {
      name: 'Giá tiền',
      fieldName: 'price',
      isHideSort: true,
      renderSpecialCard: (record: IPackageAssigned) => {
        return <span>{record.price ? formatMoney(record.price, 'đ') : ''}</span>;
      },
    },
    {
      name: 'Tiền chiết khấu',
      isHideSort: true,
      renderSpecialCard: (record: IPackageAssigned) => {
        return (
          <span>
            {record?.extraDataObject?.discountAmount
              ? formatMoney(record?.extraDataObject?.discountAmount ?? 0, 'đ')
              : ''}
          </span>
        );
      },
    },
    {
      name: 'Thành tiền',
      isHideSort: true,
      renderSpecialCard: (record: IPackageAssigned) => {
        return (
          <span>
            {record?.price
              ? formatMoney(
                  (record?.price ?? 0) - (record?.extraDataObject?.discountAmount ?? 0),
                  'đ',
                )
              : ''}
          </span>
        );
      },
    },
    {
      name: 'Tổng dung lượng',
      isHideSort: true,
      renderSpecialCard: (item: IPackageAssigned) => {
        return (
          <span>{`${item.extraDataObject?.dataGb || ''} ${
            item.extraDataObject?.dataUnit || ''
          }`}</span>
        );
      },
    },
    {
      name: 'HSD',
      fieldName: 'expireDt',
      isHideSort: true,
      renderSpecialCard: (item: IPackageAssigned) => {
        return (
          <span>{item.extraDataObject?.cycle ? `${item.extraDataObject?.cycle} ngày` : ''}</span>
        );
      },
    },
    { name: 'Trạng thái', fieldName: 'statusString', isHideSort: true },
    { name: 'Mã lỗi', fieldName: 'errorCode', isHideSort: true },
    { name: 'Mô tả lỗi', fieldName: 'errorMessage', isHideSort: true },
    {
      name: 'Ngày tạo',
      fieldName: 'createdAt',
      renderSpecialCard: (record) => {
        return <span>{record.createdAt ? formatDate(record.createdAt) : ''}</span>;
      },
    },
    { name: 'Người tạo', fieldName: 'createdBy' },
    {
      name: 'Ngày cập nhật cuối',
      fieldName: 'updatedAt',
      renderSpecialCard: (record) => {
        return <span>{record.updatedAt ? formatDate(record.updatedAt) : ''}</span>;
      },
    },
    { name: 'Người cập nhật cuối', fieldName: 'updatedBy' },
  ];

  return (
    <div>
      <Form
        onFinish={handleFormSearch}
        layout={size.width < 768 ? 'vertical' : 'inline'}
        className='gap-2'
      >
        <Form.Item name='search'>
          <Input
            prefix={<SearchOutlined />}
            placeholder='Mã đơn, STB, Mã DN, Tên DN'
            className='w-[400px]'
            allowClear
          />
        </Form.Item>
        <Form.Item name='type' label='Loại đơn hàng'>
          <Select
            showSearch
            className='min-w-[150px]'
            placeholder='Vui lòng chọn'
            defaultValue={null}
            options={[
              {
                value: null,
                label: 'Tất cả',
              },
              {
                value: TransactionHistoryType.InitiatePackage,
                label: 'Đăng ký gói',
              },
              {
                value: TransactionHistoryType.CancelPackage,
                label: 'Huỷ gói',
              },
              {
                value: TransactionHistoryType.Datacode,
                label: 'Nạp data',
              },
            ]}
          ></Select>
        </Form.Item>
        <Form.Item name='mbfCode' label='Gói'>
          <Select
            showSearch
            className='min-w-[150px]'
            placeholder='Vui lòng chọn'
            defaultValue={''}
            options={dataPackage}
            filterOption={(input, option) => {
              return nonAccentVietnamese(
                (option!.label as unknown as string).toString()?.toLowerCase(),
              ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
            }}
          ></Select>
        </Form.Item>
        <Form.Item name='subType' label='Loại thuê bao'>
          <Select
            showSearch
            className='min-w-[200px]'
            placeholder='Vui lòng chọn'
            defaultValue={''}
            options={renderOptionSubType(true)}
            filterOption={(input, option) => {
              return nonAccentVietnamese(
                (option!.label as unknown as string).toString()?.toLowerCase(),
              ).includes(nonAccentVietnamese(input?.toLowerCase()?.trim()));
            }}
          ></Select>
        </Form.Item>
        <Form.Item name='StatusString' label='Trạng thái'>
          <Select
            showSearch
            className='min-w-[150px]'
            placeholder='Vui lòng chọn'
            defaultValue={''}
            options={[
              {
                value: '',
                label: 'Tất cả',
              },
              {
                value: SimStatusEnum.Success,
                label: 'Success',
              },
              {
                value: SimStatusEnum.Failed,
                label: 'Failed',
              },
              {
                value: SimStatusEnum.New,
                label: 'New',
              },
              {
                value: SimStatusEnum.Paid,
                label: 'Paid',
              },
              {
                value: SimStatusEnum.Processing,
                label: 'Processing',
              },
              {
                value: SimStatusEnum.Canceled,
                label: 'Canceled',
              },
            ]}
          >
            {/* {renderOptions(listStatus)} */}
          </Select>
        </Form.Item>
        <Form.Item name='' label='Người tạo'>
          <Select
            showSearch
            className='min-w-[150px]'
            defaultValue={merchantInfo ? JSON.parse(merchantInfo).merchantName : ''}
          >
            {/* <Select.Option value='merchantName'>Tất cả</Select.Option> */}
            <Select.Option value='merchantName'>
              {merchantInfo ? JSON.parse(merchantInfo).merchantName : ''}
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item name='dateRange' label='Ngày tạo'>
          <DatePicker.RangePicker
            disabledDate={disabledDate}
            placeholder={['Từ ngày', 'đến ngày']}
            format={['DD/MM/YYYY', 'DD/MM/YYYY']}
          />
        </Form.Item>
        <div className='row-button' style={{ justifyContent: 'flex-end', margin: '1.5rem 0' }}>
          <Button type='primary' htmlType='submit'>
            Tìm kiếm
          </Button>
          {hasPermission(PERMISSIONS.PACKAGE_MANAGEMENT.HISTORY_EXPORT) && (
            <Button onClick={handleExport}>Export</Button>
          )}
        </div>
      </Form>
      <div className='mt-6 overflow-hidden'>
        {size.width < 1024 ? (
          <CGridView
            length={data?.results.length}
            totalRecord={data?.rowCount ?? 0}
            columns={columns}
            title={() => (
              <div className='text-xl font-bold my-3'>Danh sách lịch sử Đăng ký/Hủy gói</div>
            )}
          >
            {data?.results && data?.results.length > 0 ? (
              data?.results.map((item: IOverFlowOrderDetailResponse) => {
                return (
                  <div key={'data-row-' + item.id}>
                    <Divider className='border-t-black' />

                    <Row className='mb-6 items-center' gutter={[4, 16]}>
                      {columns.map((ele) => {
                        if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                          return (
                            <>
                              <Col span={11} className={`font-bold label`}>
                                <div className='flex gap-2 items-center'>{ele.name}</div>
                              </Col>
                              <Col className='break-words text-right' span={13}>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </Col>
                            </>
                          );
                        } else if (ele.fieldName === 'action') {
                          return (
                            <Col key={'column-' + item.id + ele.fieldName} span={24}>
                              <div className='flex gap-6'>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </div>
                            </Col>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </Row>
                  </div>
                );
              })
            ) : (
              <p>{'Không có dữ liệu'}</p>
            )}
          </CGridView>
        ) : (
          <TableContent
            bordered
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'Không tìm thấy kết quả' }}
            dataSource={data?.results ?? []}
            columns={columns}
            totalRecord={data?.rowCount ?? 0}
            sortColumn={sortColumn}
            size='middle'
            onPageChange={(pageNumber, pageSize) => {
              const pagination = parseQueryString(location.search);
              fetchListConnectionHistory({
                ...pagination,
                pageIndex: pageNumber ?? 1,
                pageSize: pageSize ?? 10,
                sortField: pagination.sortField ?? undefined,
                asc: pagination.asc ?? undefined,
              });
            }}
            onSort={(sort: ISortColumn) => {
              const pagination = parseQueryString(location.search);
              fetchListConnectionHistory({
                ...pagination,
                pageIndex: pagination.pageIndex ?? 1,
                pageSize: pagination.pageSize ?? 10,
                sortField: sort.fieldName,
                asc:
                  sort.orderType === 'asc' ? true : sort.orderType === 'desc' ? 'false' : undefined,
              });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default HistoryRegister;
